/**
 * This file contains constants for export file names used in the application.
 * These constants are used to standardize the naming of exported files.
 */
export const EXPORT_FILE_NAMES = {
    BUDGET: "WMMS Budget Export",
}
